import React, { useEffect, useState } from 'react';
import { getName } from '@/utils';
import MobxWrap from '@/components/MobxWrap';
import ossImgCompress from '@/utils/ossImgCompress';
import styles from './index.module.less';

const Index = MobxWrap(['app'], (props) => {
  const {
    item,
    app: { webp },
  } = props;
  const { thumb, name, count, commodity } = item;
  const hasSameName = getName(name, 'split') === getName(commodity.info.name, 'split');
  return (
    <div className={styles.item}>
      <img className={styles.thumb} src={ossImgCompress(thumb, { webp })} alt='' />
      <div className={styles.info}>
        <p className={styles.pName}>{getName(name, 'split')}</p>
        {!hasSameName ? <p className={styles.cName}>{commodity.info.name}</p> : null}
        <p className={styles.count}>× {count}</p>
      </div>
    </div>
  );
});

export default Index;
